import axios from "axios";
import Vue from "vue";
import { convertParamsObjectToQueryString } from "@/components/NewFilterBar/FilterBar";

const PROTOCOL = process.env.VUE_APP_PROTOCOL ? process.env.VUE_APP_PROTOCOL : "";
const HOST = process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : "";
Vue.config.url_prefix = `${PROTOCOL}://${HOST}`;

if (process.env.VUE_APP_HOST && process.env.VUE_APP_PROTOCOL)
    axios.defaults.baseURL = process.env.VUE_APP_PROTOCOL + "://" + process.env.VUE_APP_HOST + "/api";
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = "_xsrf"; // default
axios.defaults.xsrfHeaderName = "X-Xsrftoken"; // default

/*
* Axios default serializer is crap at converting array parameters to string, so we use our own
* that also takes into account the delimiters of filter objects.
*
* Used when params are passed to axios like this  ⌄⌄⌄⌄⌄
* .get(Vue.config.url_prefix + " / api / tasks / " , {params: filters})
*/


axios.defaults.paramsSerializer = bound(convertParamsObjectToQueryString, '')
Vue.use(axios);

// Helper to bind only second parameter to convertParamsObjectToQueryString
function bound(fn, ...bound_args) {
    return function(...args) {
        return fn(...args, ...bound_args);
    };
}